var Theme = Theme || {};

Theme.DocumentViewerToolbar = (function ($) {
    return {
        init: _init
    };

    function _init() {
        let $epubViewer = $('#epubViewer');
        Theme.DocumentViewerPdf.init($epubViewer);
        toggleViewerLeftRail();
        Theme.DocumentViewerEpub.init($epubViewer);
    }
    
    function toggleViewerLeftRail() {
        $('.js-open-epub-left-rail, .js-close-epub-left-rail, .epub-toc_wrap a').on('click', function () {
            let $openElements = $('.btn-epub-open-wrap');
            let $closeElements = $('.btn-epub-close-wrap');
            $('.document-viewer-left-rail').toggleClass('expanded');
            $('.left-rail').toggleClass('hide');
            $openElements.toggleClass('hide');
            $closeElements.toggleClass('hide');
        });

        $('.js-document-viewer-nextpage, .js-document-viewer-previouspage').on('click', function () {
            let $openElements = $('.btn-epub-open-wrap');
            let $closeElements = $('.btn-epub-close-wrap');
            $('.document-viewer-left-rail').removeClass('expanded');
            $('.left-rail').addClass('hide');
            $openElements.removeClass('hide');
            $closeElements.addClass('hide');
        });
    }

})(jQuery);